import React, { Fragment } from 'react'
import Grid from '@mui/material/Grid'
import LockIcon from '@mui/icons-material/Lock'

const styles = {
	editLink: {
		marginLeft: '10px',
		cursor: 'pointer',
		pointerEvents: 'all',

		'&:hover': {
			textDecoration: 'underline',
		},
	},
}

const PrivateLabel = ({ isPrivate }) => (
	<Fragment>
		{isPrivate && (
			<Grid item>
				<Grid container style={{ marginLeft: '15px', opacity:0.5 }}>
					<Grid item>
						<LockIcon
							style={{
								height: '16px',
								color: '#9b9b9b',
								marginTop:'5px'
							}}
						/>
					</Grid>
					<Grid item style={{ marginRight: '10px' }}>
						<span
							style={{
								marginLeft: '3px',
								color: '#9b9b9b',
								fontSize:'12px'
							}}
						>
							PRIVATE
						</span>
					</Grid>
				</Grid>
			</Grid>
		)}
	</Fragment>
)

export default PrivateLabel
